import { useState } from "react";
import { createCampaign } from "../services/campaign.api";
import CampaignTargetSelector from "../components/CampaignTargetSelector";
import CampaignChannelSelector from "../components/CampaignChannelSelector";
import CampaignScheduleSelector from "../components/CampaignScheduleSelector";
import { useSelector } from "react-redux";

export default function CreateCampaignScreen() {
 const currentToken = useSelector((state)=>state?.user?.user?.token);
          const appToken = useSelector((state)=>state?.app?.app?.AppToken);
          
         const tenantId = useSelector((state)=>state?.user?.user?.user_id)
  const [name, setName] = useState("");
  const [channel, setChannel] = useState("push");
  const [targetType, setTargetType] = useState("all");
  const [targetId, setTargetId] = useState(null);
  const [userIds, setUserIds] = useState([]);
  const [templateUseCase, setTemplateUseCase] = useState("");
  const [scheduledAt, setScheduledAt] = useState(null);

  async function handleSubmit() {

    await createCampaign({
      currentToken,appToken,tenantId,
      name,
      channel,
      targetType,
      targetId,
      userIds,
      templateUseCase,
      scheduledAt
    });

    alert("Campaign created");
  }

  return (
    <div style={{position:"relative",zIndex:99999}}>
      <h2>Create Campaign</h2>

      <input
        placeholder="Campaign Name"
        value={name}
        onChange={e => setName(e.target.value)}
      />

      <CampaignChannelSelector value={channel} onChange={setChannel} />

      <CampaignTargetSelector
        targetType={targetType}
        setTargetType={setTargetType}
        setTargetId={setTargetId}
        setUserIds={setUserIds}
      />

      <input
        placeholder="Template Use Case"
        value={templateUseCase}
        onChange={e => setTemplateUseCase(e.target.value)}
      />

      <CampaignScheduleSelector
        scheduledAt={scheduledAt}
        setScheduledAt={setScheduledAt}
      />

      <button onClick={handleSubmit}>
        Create Campaign
      </button>
    </div>
  );
}
